module.exports = __webpack_public_path__ + "img/keypad.b3d116c4.svg";